<template lang="html">
  <div :class="$style.tagplayContainer">
    <div :class="$style.columns">
    <div v-for="post in posts" :class="$style.column">
      <div class="tagplay-media-container tagplay-media-instagram">
        <div class="tagplay-media-inner">
          <p class="tagplay-media-username"><a :href="`https://instagram.com/${post.username}`" target="_blank">{{post.username}}</a></p>
          <div class="tagplay-media">
            <a :href="`https://www.instagram.com/p/${post.post}/`" class="tagplay-media-link" target="_blank">
              <img :src="`https://instagram.com/p/${post.post}/media/?size=l`" class="tagplay-media-object">
            </a>
          </div>
          <p class="tagplay-media-text">
            <strong>Ljósmyndari:</strong><br>
            {{post.name}}<br><br>
            <strong>Verðlaun:</strong><br>
            {{post.prize}}
          </p>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import styles from '../styles/TagplayCustom.styl';
export default {
  data() {
    return {
      posts: [
        {
          name: 'Jón Óskar Hauksson',
          username: 'jonoskarhauksson',
          prize: 'Flug fyrir tvo til Evrópu með Wow-air',
          post: 'BYgz8qxFC9y'
        },
        {
          name: 'Anna María Axelsdóttir',
          username: 'annamariaaxels',
          prize:
            'Premiumferð fyrir tvo í Bláa Lónið og óvissuferð á veitingastaðnum Lava fyrir tvo.',
          post: 'BIW9ESGDG2z'
        },
        {
          name: 'Rúnar Muccio',
          username: 'rgmuccio',
          prize: 'Gisting fyrir tvo á Hótel Keflavík',
          post: 'BYVTckcjv2h'
        },
        {
          name: 'Arnþór Guðmundsson',
          username: 'addi_gum',
          prize: 'Út að borða fyrir tvo á Fish House Grindavík.',
          post: 'BXbS04zlI_a'
        },
        {
          name: 'Jón Óskar Hauksson',
          username: 'jonoskarhauksson',
          prize: 'Hádegismatur fyrir tvo Hjá Höllu í Grindavík.',
          post: 'BYg00NuFXOd'
        },
        {
          name: 'Alla Ásmundsdóttir',
          username: 'allaasmunds',
          prize:
            'Hvalaskoðun eða sjóstöng fyrir allt að fimm manns með Whale Watching Reykjanes.',
          post: 'BYdkwBXjad2'
        },
        {
          name: 'Bjarni Lúðvíksson',
          username: 'bjarniludviksson',
          prize: 'Gisting fyrir tvo á Light House Inn í Svartsengi.',
          post: 'BC58v10jVr9'
        },
        {
          name: 'Marvin Ingi Einarsson',
          username: 'marvineinars',
          prize: 'Árskort í Víkingaheima.',
          post: 'BWN3hk7lBRD'
        },
        {
          name: 'Marvin Ingi Einarsson',
          username: 'marvineinars',
          prize: 'Sundkort í Grindavík.',
          post: 'Pmxy4eqz2i'
        },
        {
          name: 'Eygló',
          username: 'epplapie',
          prize: 'Ferð fyrir tvo um Reykjanes með Gateway to Iceland.',
          post: 'BToD-u_FtCN'
        }
      ]
    };
  }
};
</script>

<style lang="stylus" module src="../styles/TagplayWidget.styl"></style>



// WEBPACK FOOTER //
// Winners.vue?124526cd